import { Component, h, Host, Prop, Watch } from '@stencil/core';
import { ActionTrackingEvent } from '@union-investment/tracking/src/events';
import { DEFAULT_TRACKING_DELAY } from '../../global/utility/tracking-helpers';

export interface Logo {
  imageSrc: string;
  linkSrc: string;
  imageMouseover: string;
  imageAltText: string;
}

interface UiCmsPartnerLogosFooterBody {
  logos: Logo[];
}

@Component({
  tag: 'ui-cms-partner-logos-footer',
  styleUrl: 'ui-cms-partner-logos-footer.scss',
})
export class UiCmsPartnerLogosFooter {
  @Prop({ mutable: true }) body: UiCmsPartnerLogosFooterBody = {} as any;

  @Prop({ attribute: 'body' }) utilityBody: string;

  @Watch('utilityBody')
  bodyChangeHandler(newValue: string) {
    this.body = newValue ? JSON.parse(newValue) : this.body;
  }

  componentWillLoad() {
    this.bodyChangeHandler(this.utilityBody);
  }

  onLogoClick(logo: Logo) {
    const trackingEvent: ActionTrackingEvent = {
      eventInfo: {
        eventName: 'Click Partner Logo',
        eventType: 'Action',
      },
      attributes: {
        elementType: 'Link',
        elementLabel: logo.imageMouseover,
        externalTarget: logo.linkSrc,
      },
      category: {
        area: 'Footer',
      },
    };

    if (trackingEvent) {
      window.ui?.services?.tracking?.track(trackingEvent);
    }
  }

  render() {
    return (
      <Host>
        <div class="logos">
          {this.body.logos?.map((logo, index) => (
            <ui-link
              target="_blank"
              key={index}
              href={logo.linkSrc}
              onClick={() => {
                this.onLogoClick(logo);
              }}
              delay={DEFAULT_TRACKING_DELAY}
            >
              <img title={logo.imageMouseover} alt={logo.imageAltText} src={logo.imageSrc}></img>
            </ui-link>
          ))}
        </div>
      </Host>
    );
  }
}
